"use strict";
const HEADERS = [
  "Client ID",
  "Client",
  "Review %",
  "Reviewed",
  "Unchanged",
  "% Unchanged",
  "Potential Auto",
  "% Potential Autoprocessing"
];
function quote(value) {
  return '"' + String(value).replace(/"/g, '""') + '"';
}
function row(candidate) {
  return [
    candidate.carrier_id,
    candidate.name,
    // Null means the client inherits the account default, which the table renders
    // as "unset" rather than as a number it does not have.
    candidate.manual_review_percentage === null ? "unset" : candidate.manual_review_percentage,
    candidate.reviewed,
    candidate.untouched,
    candidate.pct_untouched,
    candidate.potential_autoprocessing,
    candidate.pct_potential_autoprocessing
  ].map(quote).join(",");
}
function candidatesToCsv(candidates) {
  return [HEADERS.map(quote).join(",")].concat(candidates.map(row)).join("\r\n");
}
export default candidatesToCsv;
